export default __webpack_public_path__ + "static/media/contactlogo.2d81548b.png";